import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {AuthContextProvider} from "./shared/contexts/authContext";
import {DarkModeContextProvider} from "./shared/contexts/darkModeContext";
import {PlayerContextProvider} from "./shared/contexts/playerContext";

import {Toaster} from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <DarkModeContextProvider>
        <AuthContextProvider>
            <PlayerContextProvider>
                <App/>
                <Toaster/>
            </PlayerContextProvider>
        </AuthContextProvider>
    </DarkModeContextProvider>
);